<template>
  <label
    :data-field-span="data.FieldSpan"
    :for="'input_' + data.Id"
    :data-type="data.Type"
    class="field-wrapper"
    :class="{
      focus: isFocused,
      valid: isValid,
      invalid: !isValid
    }"

  >
    <InputBoolean
      ref="input"
      v-model="value"
      :class="{ container: parent.Type !== PreApproveMe.fieldTypes.Group }"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-if="PreApproveMe.isInput(data.Type, 'boolean')"
    />
    <InputDropdown
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-else-if="PreApproveMe.isInput(data.Type, 'dropdown')"
    />
    <InputCurrency
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-else-if="PreApproveMe.isInput(data.Type, 'currency')"
    />
    <InputInteger
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-else-if="PreApproveMe.isInput(data.Type, 'integer')"
    />
    <InputDate
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-else-if="PreApproveMe.isInput(data.Type, 'date')"
    />
    <InputPhone
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-else-if="data.Id.includes('_phone')"
    />
    <InputEmail
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-else-if="data.Id.includes('_email')"
    />
    <InputSSN
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      v-else-if="data.Id.includes('_ssn')"
    />
    <InputAgreements 
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:change="evtChange"
      v-else-if="data.Type == PreApproveMe.fieldTypes.Agreements" />
    <InputText
      ref="input"
      v-model="value"
      :data="data"
      :parent="parent"
      :sectionid="sectionid"
      :pageid="pageid"
      @input:isvalid="evtValid"
      @input:isfocused="evtFocused"
      @input:value="evtValue"
      @input:change="evtChange"
      @input:created="evtCreated"
      @input:input="evtInput"
      @input:suggestion="evtSuggestion"
      v-else
    />
  </label>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

import InputBoolean from '@/inputs/InputBoolean.vue'
import InputCurrency from '@/inputs/InputCurrency.vue'
import InputDate from '@/inputs/InputDate.vue'
import InputDropdown from '@/inputs/InputDropdown.vue'
import InputEmail from '@/inputs/InputEmail.vue'
import InputInteger from '@/inputs/InputInteger.vue'
import InputPhone from '@/inputs/InputPhone.vue'
import InputSSN from '@/inputs/InputSSN.vue'
import InputText from '@/inputs/InputText.vue'
import InputAgreements from '@/inputs/InputAgreements.vue'

export default {
  name: 'FieldInput',
  components: {
    InputBoolean,
    InputCurrency,
    InputDate,
    InputDropdown,
    InputEmail,
    InputInteger,
    InputPhone,
    InputSSN,
    InputText,
    InputAgreements
  },
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      inputVal: '',
      isFocused: false,
      isValid: true,
      PreApproveMe
    }
  },
  computed: {
    value: {
      get: function() {
        return this.inputVal
      },
      set: function(val) {
        this.inputVal = val
        this.$store.state.saveData[this.$store.state.borrowerid][
          this.data.Id
        ] = val + ''
      }
    }
  },
  methods: {
    checkValid: function() {
      // Update form status
      if (this.isValid) {
        this.$store.commit('setInputValid', {
          field: this.data,
          sectionid: this.sectionid,
          pageid: this.pageid
        })
      } else {
        this.$store.commit('setInputInvalid', {
          field: this.data,
          sectionid: this.sectionid,
          pageid: this.pageid
        })
      }
    },
    parseEvtData(value) {
      return {
        Id: this.data.Id,
        Type: this.data.Type,
        Text: this.data.Text,
        Value: value
      }
    },
    evtValid: function($event) {
      this.isValid = $event
      this.$emit('field:isvalid', this.parseEvtData($event))
    },
    evtFocused: function($event) {
      this.isFocused = $event
      this.$emit('field:isfocused', this.parseEvtData($event))
    },
    evtValue: function($event) {
      this.$emit('field:value', this.parseEvtData($event))
    },
    evtChange: function($event) {
      this.$emit('field:change', this.parseEvtData($event))

      for (var i = 0; i < this.$store.state.form.dependedFields.length; i++) {
        if (this.data.Id.indexOf(this.$store.state.form.dependedFields[i]) !== -1) {
          this.$root.$emit('depend:update:' + this.data.Id)
        }
      }
      
//      if (this.$store.state.form.dependedFields.includes(this.data.Id)) {
//        this.$root.$emit('depend:update:' + this.data.Id)
//      }

      if (this.data.Id === 'smart1003_loan_details_loan_type')
        this.$root.$emit('loantype:change', $event)

      this.$store.commit('setInputValue', {
        field: this.data,
        sectionid: this.sectionid,
        pageid: this.pageid,
        value: $event
      })
    },
    evtCreated: function($event) {
      this.$emit('field:created', this.parseEvtData($event))
    },
    evtInput: function($event) {
      this.$emit('field:input', this.parseEvtData($event))
    },
    evtSuggestion: function($event) {
      this.$emit('field:suggestion', this.parseEvtData($event))
    },
    onBorrowerChange: function($event) {
      var old = this.value

      this.$store.commit('initInputValue', {
        field: this.data,
        sectionid: this.sectionid,
        pageid: this.pageid,
        datakey: this.data.datakey
      })

      this.value = this.$store.state.saveData[this.$store.state.borrowerid][this.data.Id]
      //this.isValid = this.$store.state.form.status[this.$store.state.borrowerid][this.sectionid][this.pageid]

      if (old != this.value)
        this.evtChange(this.value)
    },
    onFormUpdate: function ($event) {
      // Reload value in case it changed
      this.inputVal = this.$store.state.saveData[this.$store.state.borrowerid][this.data.Id]
    }
  },
  created: function() {
    this.isValid = !this.data.Required

    this.$store.commit('addInput', {
      field: this.data,
      sectionid: this.sectionid,
      pageid: this.pageid
    })

    var old = this.value
    // Make sure a value exists in saveData
    this.$store.commit('initInputValue', {
      field: this.data,
      sectionid: this.sectionid,
      pageid: this.pageid,
      datakey: this.data.datakey
    })

    this.$root.$on('borrower:change', this.onBorrowerChange)
    this.$root.$on('form:update', this.onFormUpdate)

    // Check if pre-filled (start off invalid?)
    if (this.data.Value) {
      this.value = this.data.Value
    }

    if (old != this.value)
      this.evtChange(this.value)
//    if (this.$store.state.saveData[this.$store.state.borrowerid][this.data.Id])
//      this.value = this.$store.state.saveData[this.$store.state.borrowerid][this.data.Id]
  },
  updated: function() {
    this.checkValid()
  },
  destroyed: function() {
    this.$root.$off('borrower:change', this.onBorrowerChange)
    this.$root.$off('form:update', this.onFormUpdate)

    this.$emit('field:delete', this.parseEvtData(true))
    this.$store.commit('removeInput', {
      field: this.data,
      sectionid: this.sectionid,
      pageid: this.pageid
    })
  },
  watch: {
    isValid: function(isValid) {
      this.checkValid()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.field-wrapper {
}
</style>
